import axios from 'axios';
import { compressMediaFiles } from './imageCompression';

export const STORY_MAX_BYTES = 25 * 1024 * 1024;

/**
 * Upload one photo/video and publish it as a story.
 * Throws on failure; `onProgress` receives 0–100 during the upload.
 */
export const publishStory = async (file, caption = '', onProgress) => {
  const isVideo = file.type.startsWith('video');
  const [fileToUpload] = await compressMediaFiles([file], { type: 'story' });
  if (fileToUpload.size > STORY_MAX_BYTES) {
    const err = new Error('Media file exceeds 25MB limit');
    err.code = 'too_large';
    throw err;
  }

  const formData = new FormData();
  formData.append('file', fileToUpload);
  formData.append('subfolder', 'stories');
  const uploadRes = await axios.post('/api/upload/single', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    onUploadProgress: (e) => {
      if (onProgress && e.total) onProgress(Math.round((e.loaded * 100) / e.total));
    },
  });
  const mediaUrl = uploadRes.data?.url;
  if (!mediaUrl) throw new Error('Upload returned empty URL');

  await axios.post('/api/stories', {
    mediaUrl,
    mediaType: isVideo ? 'video' : 'image',
    caption: caption.trim() || null,
  });
};
